import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Button from '../Common/Button';
import Toggle from '../Common/Toggle/Toggle';
import Notification from '../../components/Common/Notification';
import * as types from '../../constants/actionTypes';
import Modal from '../Common/Modal/Modal';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class ActiveToggleForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isFormValid: true,
            isLoading: false,
            isActive: true,
            isLocationTaskListActive: false,
            showErrorModal: false,
            invalidTasks: [],
            copied: false
        };
    }

    onToggleChange = (property, value) => {
        this.setState({ [property]: value });
    }

    validate = () => {
        if (this.props.tasksChecked == null || this.props.tasksChecked.length < 1) 
        {
            this.setState({isFormValid: false});
            return false;
        }
        
        //all selected tasks must be the same (all active or all inactive)
        let invalidTask =  this.props.tasksChecked.find(t => t.isActive === this.state.isActive);
        if (invalidTask) 
        {
            this.setState({isFormValid: false});
            let activeString = this.state.isActive ? "active" : "inactive";
            Notification("error", "Active Toggle Error", "Baseline Task \"" + invalidTask.name + "\" is already " + activeString);
            return false;
        }

        this.setState({isFormValid: true});
        return true;
    }

    onSaveClick = () => {
        if (this.validate() === true) {
            this.saveToggle();
        }
    }

    async saveToggle() {
        try {
            this.setState({ isLoading: true });
            const checkedTasks = this.props.tasksChecked.map(bt => bt.id);
            const result = await this.props.baselineTaskActions.activeToggle(checkedTasks, this.state.isActive, this.state.isLocationTaskListActive);
            if (result.type === types.TOGGLE_ACTIVE_TASK_SUCCESS) {              
                if (result.payload.invalidBaselineTasks && result.payload.invalidBaselineTasks.length > 0) {
                    const invalidTasks = result.payload.invalidBaselineTasks;
                    this.setState({ isLoading: false, showErrorModal: true, invalidTasks: invalidTasks, copied: false });
                }
                else {
                    const successText = `Task${checkedTasks.length > 1 ? '(s)' : '' } successfully ${this.state.isActive ? 'activated' : 'inactivated'}`;
                    Notification("success", "Success", successText);
                    this.props.listingRefresh();
                }
            } else if (result.type === types.TOGGLE_ACTIVE_TASK_FAILURE) {
                Notification("error", "Error", result.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    closeModalWarning = () => {
        this.setState({ showErrorModal: false, invalidTasks: [] });
    }

    render () {
        const modalBody = <div>
            <p>The relationship to the prerequisite needs to be removed before the task(s) can be made inactive:</p>
            {this.state.invalidTasks.slice(0, 10).map(t => {
                return <p className="invalid-task-item" key={t.id}>{t.name}</p>
            })}
            <p>Total: {this.state.invalidTasks.length}</p>
        </div>;
        const modalFooter = <div>
            <CopyToClipboard 
                options={{ format: "text/plain" }}
                text={this.state.invalidTasks.map(t => t.name).join(',')}
                onCopy={() => this.setState({copied: true})}>
                <button type="button" className={this.state.copied === true ? "btn btn-light" : "btn btn-primary"} onClick={this.copyErrorDetails}>Copy Error Details</button>
            </CopyToClipboard>
            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.closeModalWarning}>Ok</button>
        </div>;
        return (
            <Fragment>
                
                <div className="container">
                    <div className="row w-100 toggle-dockbar">
                        <div className="col-3">
                            <span className="align-middle">{this.props.tasksChecked.length} Task{this.props.tasksChecked.length === 1 ? "" : "s"} Selected</span>
                        </div>
                        <div className="col-2">
                            <span className="align-middle">Mark Selected Tasks As:</span>
                        </div>
                        <div className="col-2">
                            <Toggle name="isActive" text="Active" checked={this.state.isActive} onChange={this.onToggleChange} />
                        </div>
                        <div className="col-4">
                            {this.state.isActive === false &&
                                <Toggle name="isLocationTaskListActive" text="Visible in Location Task List" checked={this.state.isLocationTaskListActive} onChange={this.onToggleChange} />
                            }
                        </div>
                        <div className="col-1">
                            <div className="float-end">
                                <Button type="button" bootstrapClass="primary" text="Apply Changes" onClick={this.onSaveClick} />
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showErrorModal &&
                    <Modal
                        id="managerWarning"
                        title="Error: Contigent Tasks"
                        body={modalBody}
                        onCloseClick={this.closeModalWarning}
                        customFooter={modalFooter} />}
            </Fragment>
        );
    }
}

ActiveToggleForm.propTypes = {
    tasksChecked: PropTypes.array.isRequired,
    baselineTaskActions: PropTypes.object.isRequired,
    listingRefresh: PropTypes.func.isRequired
};

export default ActiveToggleForm;